import { API_BASE_URL, USER_PERMISSIONS_API } from "utilities";
import axios from "axios";
import ToastAlert from "../../utilities/toastAlert/toastAlert";
import { errorMessage } from "../../utilities/actionMessages";
import { authenticationLogout } from "./authentication";
import { getApiErrorMessage } from "../../utilities/CommonFunctions";

export const getUserPermissions = () => {
  let URL = API_BASE_URL + USER_PERMISSIONS_API;
  return (dispatch) => {
    dispatch({
      type: "GET_ACL_FETCHING",
    });
    axios
      .get(URL, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then(function (response) {
        dispatch({
          type: "GET_ACL_SUCCESS",
          data: response.data || {},
        });
      })
      .catch(function (error) {
        if (error && error.response && error.response.status === 401) {
          dispatch(authenticationLogout());
        }
        ToastAlert({ message: getApiErrorMessage(error, errorMessage), type: "error" });
        dispatch({
          type: "GET_ACL_FAILURE",
          error: error.message,
        });
      });
  };
};
